import { render, staticRenderFns } from "./MassiveImportItemEmpresa.vue?vue&type=template&id=6f744210&"
import script from "./MassiveImportItemEmpresa.vue?vue&type=script&lang=js&"
export * from "./MassiveImportItemEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports